module.exports = __webpack_public_path__ + "media/images/playcricle-9904fb1d.png";